import { Button } from '@smithhealth/design-system';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DrugAutocomplete } from '@components/drug-autocomplete/drug-autocomplete';
import { Card } from '@components/sds/card/card';
import ChevronRightIcon from '@components/sds/icons/chevron-right';
import DocumentIcon from '@components/sds/icons/document';
import { useSelectedPharmacy } from '@services/pharmacy';
import styles from './home.module.scss';

export const Home = () => {
  const { selectedPharmacy } = useSelectedPharmacy();
  const navigate = useNavigate();

  const [selected, setSelected] = useState<string | undefined>();

  const onSearch = () => {
    navigate({ pathname: './mac', search: selected });
  };

  const onClickDocuments = () => navigate('./documents');

  if (!selectedPharmacy) {
    return <></>;
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.header}>
        Welcome {selectedPharmacy.name}{' '}
        {selectedPharmacy.location?.address1
          ? `at ${selectedPharmacy.location.address1}`
          : ''}
      </h1>
      <div className={styles.searchContainer}>
        <DrugAutocomplete selected={selected} setSelected={setSelected} />
        <Button
          hierarchy="primary"
          variant="brand"
          icon="search"
          iconPosition="start"
          disabled={!selected}
          onClick={onSearch}
        >
          Search
        </Button>
      </div>
      <Link className={styles.link} to="./mac">
        View Entire MAC List
      </Link>

      <div className={styles.cardContainer}>
        <Card onClick={onClickDocuments}>
          <div className={styles.icon}>
            <DocumentIcon />
          </div>
          <div className={styles.cardText}>
            <header>Forms & Documents</header>
            <p>
              Access resources, manuals, documents and forms associated with
              network participation
            </p>
          </div>
          <ChevronRightIcon />
        </Card>
      </div>
    </div>
  );
};
